module.exports = __webpack_public_path__ + "static/media/lena3.fae8fbb5.jpg";